import { AttachmentProps } from './attachment'
import { QuestionProps } from './question'

export interface TaskProps {
    id?: string | number
    _id?: any
    title?: string
    details?: string
    creation_date?: string
    end_date?: string
    startDate?: number
    endDate?: number
    priority?: string
    role?: string
    assignment?: string[]
    assignmentUserId?: string[]
    questions?: QuestionProps[]
    attachments?: AttachmentProps[]
    projectId?: ProjectIdProps
    delegated?: {
        creation_date?: string
        creation_time?: string
        new_assignee?: string
    }
    status?: string
    progress?: number
    delegateUserInfo?: {
        name?: string
        lastname?: string
        nickname?: string
        userId?: string
        role?: string
        date?: number
    }
}

export interface ProjectIdProps {
    _id?: string
    storeId?: string
    jobsquestionId?: string
}

export interface Approver {
    role: string
    name?: string
    selected?: boolean
}

export enum TaskSubType {
    HIGH_QUALITY = 'high_visibility',
    MAINTENANCE = 'maintenance',
    SERVICE_REQUEST = 'serviceRequest',
}
